'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.uint8-array.set-from-base64');
